import get from "lodash/get";

const geometryConfig = {
    fer: {
        displayName: "FER",
        geojsonUrl:
            process.env.PUBLIC_URL +
            "/data/fer-generalised-simplified-0.008-topo.json",
        idSelector: feature => get(feature, ["properties", "ID"]),
        idCol: "ID",
        nameSelector: feature => get(feature, ["properties", "FER_NAME"]),
        topologyObjectsName: "fer-generalised-simplified-0",
    },
    regions: {
        displayName: "DPC Regions",
        geojsonUrl:
            process.env.PUBLIC_URL +
            "/data/dpc-regions-generalised-simplified-0.0008-topo.json",
        idSelector: feature => get(feature, ["properties", "CADID"]),
        idCol: "CADID",
        nameSelector: feature => get(feature, ["properties", "REGION"]),
        topologyObjectsName: "dpc-regions-generalised-simplified-0",
    },
    lga: {
        displayName: "LGA",
        geojsonUrl:
            process.env.PUBLIC_URL +
            "/data/lga-nsw-2016-simplified-0.0008-topo.json",
        idSelector: feature => get(feature, ["properties", "LGA_CODE16"]),
        idCol: "LGA_CODE16",
        nameSelector: feature => get(feature, ["properties", "LGA_NAME16"]),
        topologyObjectsName: "lga-nsw-2016-simplified-0",
    },
    electorates: {
        displayName: "Electorates",
        geojsonUrl:
            process.env.PUBLIC_URL +
            "/data/sed-nsw-2016-simplified-0.0008.json",
        idSelector: feature => get(feature, ["properties", "SED_CODE16"]),
        idCol: "SED_CODE16",
        nameSelector: feature => get(feature, ["properties", "SED_NAME16"]),
        topologyObjectsName: "sed-nsw-2016-simplified-0",
    },
};

export default geometryConfig;



// WEBPACK FOOTER //
// ./src/modules/geometryConfig.js